import { styled } from '@mui/material/styles'
import React, { useEffect, useRef, useState } from 'react'
import { useLayoutContext } from '../../context/LayoutProvider/LayoutProvider'
import HorizontalNavSections from './HorizontalNavSections'

const NAV_HEIGHT = 50

interface FloatingNavBarContainerProps {
  pinned?: boolean
  visible?: boolean
}

// Adjust the transform logic based on pinned
const FloatingNavBarContainer = styled('nav')<FloatingNavBarContainerProps>(({ theme, pinned, visible }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0, // Ensures it stops short of BoardOptionsNavContainer
  height: `${NAV_HEIGHT}px`, // MATCHES BoardOptionsNavContainer height
  bgcolor: theme.palette.background.section,
  color: theme.palette.text.primary,
  boxShadow: theme.shadows[5],
  borderBottom: `1px solid ${theme.palette.divider}`, // Matches BoardOptionsNavContainer
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  transition: 'all 0.3s ease',
  opacity: 1,
  transform: pinned ? 'translateY(0)' : visible ? 'translateY(0)' : 'translateY(-100%)',
  zIndex: 1300,
}))

const FloatingNavBar = props => {
  const {
    handleOpenCreateOrganization,
    handleOpenCreateDeal,
    handleOpenCreateContact,
    onOpenCreateTask,
    onCloseCreateTask,
    onOpenCreativeIntake,
    onCloseCreativeIntake,
    onOpenMarketingForm,
    onCloseMarketingForm,
    onOpenCreateBatchDigital,
    onCloseCreateBatchDigital,
    isConnectedUsersOpen,
    handleOpenConnectedUsers,
    handleCloseConnectedUsers,
    selectedPath,
    handleNavigation,
    user,
    unreadCount,
    // New pinned props
    pinned,
    onTogglePinned,
    isLoading,
  } = props

  // We keep old "hover to show" logic in place, but only if pinned = false
  const [visible, setVisible] = useState(false)
  const hideTimeoutRef = useRef(null)
  const { setNavOpenState } = useLayoutContext()

  const handleMouseEnter = () => {
    if (!pinned) {
      clearTimeout(hideTimeoutRef.current)
      setVisible(true)
    }
  }

  const handleMouseLeave = () => {
    if (!pinned) {
      hideTimeoutRef.current = setTimeout(() => {
        setVisible(false)
      }, 500)
    }
  }

  // Show nav if user’s cursor is near the bottom
  useEffect(() => {
    if (pinned) {
      // If pinned, always visible. Just set it once.
      setVisible(true)
      return
    }

    const handleMouseMove = e => {
      const threshold = 20
      if (e.clientY <= threshold) {
        setVisible(true)
      }
    }

    window.addEventListener('mousemove', handleMouseMove)

    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      clearTimeout(hideTimeoutRef.current)
    }
  }, [pinned])
  useEffect(() => {
    // Now we set navOpen to the same as `visible`,
    // instead of toggling it
    setNavOpenState(visible)
  }, [visible, setNavOpenState])
  return (
    <>
      <FloatingNavBarContainer
        pinned={pinned}
        visible={visible}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Left side nav sections */}
        <HorizontalNavSections
          handleOpenCreateOrganization={handleOpenCreateOrganization}
          handleOpenCreateDeal={handleOpenCreateDeal}
          handleOpenCreateContact={handleOpenCreateContact}
          onOpenCreateTask={onOpenCreateTask}
          onCloseCreateTask={onCloseCreateTask}
          onOpenCreateBatchDigital={onOpenCreateBatchDigital}
          onCloseCreateBatchDigital={onCloseCreateBatchDigital}
          onOpenCreativeIntake={onOpenCreativeIntake}
          onCloseCreativeIntake={onCloseCreativeIntake}
          onOpenMarketingForm={onOpenMarketingForm}
          onCloseMarketingForm={onCloseMarketingForm}
          isConnectedUsersOpen={isConnectedUsersOpen}
          handleOpenConnectedUsers={handleOpenConnectedUsers}
          handleCloseConnectedUsers={handleCloseConnectedUsers}
          // isNotifyDrawerOpen={isNotifyDrawerOpen}
          // onOpenNotify={onOpenNotify}
          // onCloseNotify={onCloseNotify}
          selectedPath={selectedPath}
          handleNavigation={handleNavigation}
          user={user}
          unreadCount={unreadCount}
          // devSectionIds={devSectionIds}
          // imageUrl={imageUrl}
          checked={pinned}
          onChecked={onTogglePinned}
          isLoading={isLoading}
        />
      </FloatingNavBarContainer>
    </>
  )
}

export default React.memo(FloatingNavBar)
